// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ModalThanks_wrap__1wXJ5","body":"ModalThanks_body__LjTQ6","footer":"ModalThanks_footer__3fSs0","btn":"ModalThanks_btn__qUnBN"};